import { render, staticRenderFns } from "./ComposePot.vue?vue&type=template&id=f7795454"
import script from "./ComposePot.vue?vue&type=script&lang=js"
export * from "./ComposePot.vue?vue&type=script&lang=js"
import style0 from "./ComposePot.vue?vue&type=style&index=0&id=f7795454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports